<script setup lang="ts">
defineProps<{
  highlights: {
    title: string
    description: string
  }[]
}>()
</script>

<template>
  <ul class="product-highlights">
    <li
      v-for="item in highlights"
      :key="item"
      class="product-highlights__item"
    >
      <div class="product-highlights__heading">
        {{ item.title }}
      </div>
      <p class="product-highlights__description">
        {{ item.description }}
      </p>
    </li>
  </ul>
</template>

<style>
@import url('~layers/components/Product/Highlights.css');
</style>
